var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFluentMail24Regular(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "fluent:mail-24-regular"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.65541 8.21411H34.4858C36.0126 8.21401 37.4817 8.79818 38.5915 9.84679C39.7013 10.8954 40.3678 12.329 40.4543 13.8534L40.4635 14.1918V31.665C40.4636 33.1919 39.8794 34.6609 38.8308 35.7707C37.7822 36.8805 36.3486 37.547 34.8242 37.6335L34.4858 37.6427H9.65541C8.12855 37.6428 6.65953 37.0586 5.5497 36.01C4.43987 34.9614 3.77337 33.5278 3.68693 32.0034L3.67773 31.665V14.1918C3.67763 12.6649 4.26181 11.1959 5.31042 10.0861C6.35903 8.97625 7.79257 8.30975 9.31698 8.22331L9.65541 8.21411ZM37.7045 18.0966L22.7143 25.9871C22.5451 26.0765 22.3591 26.1298 22.1681 26.1434C21.9772 26.157 21.7855 26.1307 21.6053 26.0662L21.4287 25.989L6.43666 18.0984V31.665C6.43669 32.4728 6.74046 33.2511 7.28766 33.8453C7.83487 34.4395 8.5855 34.8062 9.39056 34.8727L9.65541 34.8838H34.4858C35.2939 34.8837 36.0724 34.5797 36.6666 34.0321C37.2609 33.4845 37.6275 32.7334 37.6935 31.928L37.7045 31.665V18.0966ZM34.4858 10.973H9.65541C8.84762 10.9731 8.06936 11.2768 7.47514 11.824C6.88092 12.3712 6.51417 13.1219 6.4477 13.9269L6.43666 14.1918V14.9808L22.0706 23.208L37.7045 14.979V14.1918C37.7045 13.3837 37.4004 12.6052 36.8528 12.0109C36.3053 11.4167 35.5542 11.0501 34.7488 10.9841L34.4858 10.973Z",
    fill: "#256D9D"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFluentMail24Regular);
export default __webpack_public_path__ + "static/media/fluent_mail-24-regular.448aaf404411f91c44cb009df0e88f0c.svg";
export { ForwardRef as ReactComponent };